import React from "react";
import * as Checkbox from "@radix-ui/react-checkbox";
import { Controller, useFormContext } from "react-hook-form";
import { signUpFormValidators } from "../../../helpers/signUpFormConstants";
import Check from "../../../svgs/FilledCheck";
import { SignUpFormData } from "../../../SignUpFormTypes/signUpFormTypes";
import { useSignUpForm } from "../SignUpFormContext";
import { injectStylesInString } from "../signUpHelpers";

const AgreementInput = () => {
  const { control } = useFormContext<SignUpFormData>();
  const { useSignUpTermsQuery } = useSignUpForm();
  const { text } = useSignUpTermsQuery();
  const INPUT_NAME = "agreement";

  const isAgreementWithOffer = () => {
    const offerContainer = document.getElementById("offerContainer");
    if (!offerContainer) return false;

    return true;
  };

  return (
    <Controller
      name={INPUT_NAME}
      rules={signUpFormValidators.required}
      control={control}
      render={({ field: { value, onChange, ...field } }) =>
        text != "" ? (
          <div
            className={`flex justify-center items-start gap-[10px] self-stretch rounded-xl p-3
          ${isAgreementWithOffer() ? "bg-white" : "bg-forest-100"}`}
          >
            <Checkbox.Root
              id={INPUT_NAME}
              checked={value}
              onCheckedChange={onChange}
              className={`flex flex-col p-0 size-5 items-start gap-2 shrink-0 rounded bg-white
                ${!value && "border border-solid border-[#DDD]"}`}
              {...field}
            >
              <Checkbox.Indicator className="size-full shrink-0 text-forest-900">
                <Check background="#FFC600" stroke="#123333" />
              </Checkbox.Indicator>
            </Checkbox.Root>
            <div
              className="font-sans text-sm text-[#333] not-italic font-normal leading-[165%]
          *:font-sans *:text-sm *:text-[#333] *:not-italic *:font-normal *:leading-[165%]"
              dangerouslySetInnerHTML={{
                __html: injectStylesInString(
                  text,
                  "a",
                  "font-sans text-[#333] text-sm not-italic font-semibold leading-[165%] underline"
                ),
              }}
            />
          </div>
        ) : (
          <div />
        )
      }
    />
  );
};

export default AgreementInput;
